import moment from 'moment';

export function formatDateISO(d: Date): string {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
}

export function parseDateISO(str: string): Date {
  const [y, m, d] = str.split('-').map(Number);
  return new Date(y, m - 1, d);
}

export function todayISO(): string {
  return formatDateISO(new Date());
}

export function toDateISO(year: number, month: number, day: number): string {
  return formatDateISO(new Date(year, month, day));
}

export function formatDateShort(dateStr: string): string {
  const m = moment(dateStr, 'YYYY-MM-DD');
  return m.isValid() ? m.format('D MMM') : dateStr;
}

export function formatDateWithWeekday(dateStr: string): string {
  const m = moment(dateStr, 'YYYY-MM-DD');
  return m.isValid() ? m.format('ddd, D MMM') : dateStr;
}

export function formatDisplayDate(dateStr: string): string {
  const m = moment(dateStr, 'YYYY-MM-DD');
  return m.isValid() ? m.format('D MMM YYYY') : dateStr;
}
